import React, { forwardRef } from 'react';
import type { TabBaseProps } from '../../common/types.tsx';

const AnchorTab = forwardRef<HTMLAnchorElement, TabBaseProps>(
	({ children, isDraggable, isDragging, ...props }, ref) => (
		// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
		<a ref={ref} {...props}>
			{children}
		</a>
	),
);

export default AnchorTab;
